import Immutable from 'immutable';

import DailyMenu           from './daily_menu';
import GroupMenuWithOrders from './group_menu_with_orders';

export default class DailyMenuWithOrders extends DailyMenu {
  isSaved() {
    return this.groupMenus().every(groupMenu => groupMenu.isSaved());
  }

  hasSelection() {
    return this.groupMenus().some(groupMenu => groupMenu.hasSelection());
  }

  allAdditionalMealsSelected() {
    return this.groupMenus().every(groupMenu => groupMenu.allAdditionalMealsSelected());
  }

  orders() {
    const menus = this._groupMenus?.map(this._groupMenuFor.bind(this)) ?? new Immutable.Map;

    return menus.filter(gm => !gm.isSaved()).map(gm => gm.orders());
  }

  _groupMenuFor(courseMenus, groupName) {
    const group = this._menu.groups.find(groupName);

    return new GroupMenuWithOrders(this.canteen, this.date, group, courseMenus, this._menu);
  }
}
